<template>
  <div>
    <v-form ref="form" @submit.prevent>
      <v-row justify="center">
        <v-col cols="12" lg="8">
          <v-text-field
            :rules="[
              v => !!v || 'Campo obrigatório',
              v => (v && v.length <= 50) || 'O campo deve ter no máximo 50 caracteres'
            ]"
            outlined
            v-model="name"
            label="Confirme seu nome no campo abaixo."
            placeholder="Digite seu nome"
            id="id"
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="8">
          Selecione umas das opções de assinatura, ela será usada para assinar seu ASO no final do atendimento.
        </v-col>
        <v-col
          cols="12"
          lg="8"
          v-for="font in fonts"
          :key="font.name"
          class="pa-1 ma-0"
          @click="resolveSelectedFont(font)"
        >
          <div class="font-preview">
            <div class="icon-checked">
              <v-icon v-if="selectedFont && selectedFont.attribute === font.attribute" color="#4248f5" class="ma-0 pa-0"
                >mdi-check-circle</v-icon
              >
            </div>
            <div :style="{ 'font-family': font.attribute }">
              {{ name ? name : font.name }}
            </div>
          </div>
        </v-col>
        <v-col cols="12" v-if="errorSelectedFont">
          <v-alert class="mt-2" outlined color="error" :value="errorSelectedFont">
            É obrigatório selecionar uma assinatura
          </v-alert>
        </v-col>
        <v-col cols="12">
          <v-checkbox :rules="[v => !!v || 'Campo obrigatório']">
            <template #label>
              <small>
                Declaro que fui devidamente informado(a) pelo médico(a) sobre o atendimento médico utilizando recursos
                tecnológicos (Telemedicina) e que estou de acordo com esse tipo de atendimento.
              </small>
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" class="text-center justify-end">
          <v-btn color="primary" :loading="loading" @click="saveAssinatura()">Salvar</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import base64toFile from '@/utils/base64toFile'
import assinaturaService from '@/services/assinatura'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    dialog: false,
    file: [],
    fonts: [
      {
        name: 'Dawning of a New Day',
        attribute: "'Dawning of a New Day', cursive"
      },
      {
        name: 'Reenie Beanie',
        attribute: "'Reenie Beanie', cursive"
      }
    ],
    name: null,
    selectedFont: null,
    errorSelectedFont: false,
    loading: false
  }),
  computed: {
    backendUrl() {
      return process.env.VUE_APP_API_URL
    },
    ...mapGetters('user', ['nome'])
  },
  methods: {
    onFileChange(file) {
      if (!file || Array.isArray(file)) {
        this.file = []
        this.cropped = null
        return
      }

      this.file = file
      this.dialog = true
    },
    validateFont() {
      this.errorSelectedFont = !this.selectedFont
      return !!this.selectedFont
    },
    async saveAssinatura() {
      if (this.$refs.form.validate() && this.validateFont()) {
        const canvas = document.createElement('canvas')
        canvas.height = 50

        const ctx = canvas.getContext('2d')
        ctx.font = `bold 40px ${this.selectedFont.name}`
        ctx.fillText(this.name, 1, 40)

        // Define o tamanho do canvas com base no tamanho do texto
        canvas.width = ctx.measureText(this.name).width + 10
        // Preenche novamente com a fonte definida e o tamanho atualizado
        ctx.font = `bold 40px ${this.selectedFont.name}`
        ctx.fillText(this.name, 1, 40)
        const dataURL = canvas.toDataURL()
        const file = await base64toFile(dataURL, 'temp.png', 'image/png')
        await this.storeAssinatura(file)
        this.$emit('assinatura-saved')
      }
    },
    selectFontColor(color) {
      this.selectedFontColor = color
    },
    colorIsSelected() {},
    async storeAssinatura(assinatura) {
      try {
        this.loading = true
        await assinaturaService.storeAssinatura(assinatura)
        this.$showSuccessMessage('Assinatura salva com sucesso')
      } catch (error) {
        this.$showErrorMessage(
          'Houve um erro ao salvar a assinatura, se o erro persistir, entre em contato com o suporte'
        )
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    resolveSelectedFont(font) {
      if (this.selectedFont === font) {
        this.selectedFont = null
      } else {
        this.selectedFont = font
      }
    }
  },
  mounted() {
    this.name = this.nome
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Dawning+of+a+New+Day&family=Reenie+Beanie&display=swap');
.icon-checked {
  position: relative;
  background-color: #fff;
  border-radius: 50%;
  min-width: 20px;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.font-preview {
  background-color: #d2dae8;
  border: 1px solid #00000038;
  display: flex;
  align-items: center;
  height: 100px;
  font-size: 20px;
  padding: 20px;
  user-select: none;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  text-overflow: ellipsis;
  overflow: hidden;
  max-height: 6rem;
}
.font-preview:hover {
  transform: scale(1.01);
  -webkit-transition: all 100ms ease-in-out;
  transition: all 100ms ease-in-out;
  cursor: pointer;
}
</style>
